import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import defaultImage from "../../assets/images/defaultImage.png";

const Image = ({ src, width, height, alt, effect, classes, onError = () => {} }) => {
  return (
    <>
      <LazyLoadImage
        onError={onError}
        src={src || defaultImage}
        width={width}
        height={height}
        alt={alt}
        effect={effect}
        className={"w-full h-full " + classes}
        // onError={() => defaultImage}
      />
    </>
  );
};

export default Image;
